import { render, staticRenderFns } from "./store-buy.vue?vue&type=template&id=f3e33520"
import script from "./store-buy.vue?vue&type=script&lang=js"
export * from "./store-buy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports